import { useMemo } from 'react';
import { US_REGION_CODE } from '../../../../../constants.ts';
import type { Group } from '../../../../../types.ts';
import { getCountriesFromGroup, getRegionFromGroup } from '../../utils/guards.ts';

type MarketSelectionParams = {
  marketContext?: {
    region?: string | null;
    countries?: string[];
  };
  segmentsGroup: Group | undefined;
};

type MarketSelection = {
  hasMarketSelection: boolean;
  isNonUSMarket: boolean;
  marketContext:
    | {
        regionCode: string | null;
        countries: string[];
      }
    | undefined;
};

export const useMarketSelection = ({ marketContext, segmentsGroup }: MarketSelectionParams): MarketSelection => {
  const { hasMarketSelection, isNonUSMarket, marketContextObj } = useMemo(() => {
    const selectedRegionCode = marketContext?.region ?? getRegionFromGroup(segmentsGroup);
    const selectedCountries = marketContext?.countries ?? getCountriesFromGroup(segmentsGroup);
    const hasMarketSelection = selectedRegionCode != null || selectedCountries.length > 0;
    const isNonUSMarket = hasMarketSelection && selectedRegionCode !== US_REGION_CODE;

    const marketContextObj = hasMarketSelection
      ? {
          regionCode: selectedRegionCode,
          countries: selectedCountries,
        }
      : undefined;

    return {
      hasMarketSelection,
      isNonUSMarket,
      marketContextObj,
    };
  }, [marketContext?.region, marketContext?.countries, segmentsGroup]);

  return {
    hasMarketSelection,
    isNonUSMarket,
    marketContext: marketContextObj,
  };
};
